import {Injectable, computed, signal} from '@angular/core';
import {UserType} from '../models/user.model';


@Injectable({providedIn: 'root'})
export class AppStateService {
  readonly isAuthenticated = signal(false);
  readonly userType = signal<UserType>(null);
  readonly userName = signal('');
  readonly userEmail = signal('');
  readonly isNewUser = signal(false);

  readonly isOwner = computed(() => this.userType() === 'owner');
  readonly isTenant = computed(() => this.userType() === 'tenant');

  authenticate(type: UserType, name: string, email = '', isNewUser = false): void {
    this.userType.set(type);
    this.userName.set(name);
    this.userEmail.set(email);
    this.isNewUser.set(isNewUser);
    this.isAuthenticated.set(true);
  }

  logout(): void {
    this.isAuthenticated.set(false);
    this.userType.set(null);
    this.userName.set('');
    this.userEmail.set('');
    this.isNewUser.set(false);
  }
}
